export default __webpack_public_path__ + "static/6-4960dad33de95b463748fbc0ec43ec75.png";